import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
    "https://zivjfmaqqestdumiimji.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InppdmpmbWFxcWVzdGR1bWlpbWppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDE1NTkzMjgsImV4cCI6MjAxNzEzNTMyOH0.MPo7FdZnO6Cx4WSEmsSE6nAC4XtxympNIsU566tQeuI"
)